import statusLabel from './statusLabel'

export default {
  statusLabel,
}
